import React, {useContext, useState} from 'react'
import { Link } from 'react-router-dom';
import './navbar.css'
import { Context } from "../../context/Context";
import Avatar from 'react-avatar';

function Navbar() {
    const {user} = useContext(Context);

    const [dropDown, setDropDown] = useState(false);

    return (
        <>
        <div className="navbar">
            <Link to="/" className="logo-link">
                <div className="logo"> mentorX </div>
            </Link>            
            <div>
           
            {user ?  <div className="nav-profile">
                <Avatar onClick={() => setDropDown(!dropDown)} name={user.username} size="40" round={true} textSizeRatio={2.6} /> </div> :
            <Link to="/login" className="logo-link">
            <div className="login-btn">Login</div>
           </Link>    
            }
            {
                dropDown &&  <div className="profile-drop-down">
                <ul>
                    <li className="profile-drop-down-item">Logout</li>
                </ul>
            </div>
            }
            </div>
        </div>
        
         </>
    )
}

export default Navbar
